let bodyScrollLock: any;
if (typeof window !== "undefined") {
  bodyScrollLock = require("body-scroll-lock");
}
import * as React from "react";
import IFrame from "react-iframe";
import Button from "../button/button";
import Modal from "../modal/modal";

interface ISubscriptionState {
  readonly modalIsOpen: boolean;
}

class Subscription extends React.Component<
  { className?: string },
  ISubscriptionState
> {
  public static defaultProps = "btn--arrow-right";
  private navigationRef: HTMLElement = null;

  constructor() {
    super();

    this.state = {
      modalIsOpen: false
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  public componentDidMount() {
    this.navigationRef = document.querySelector(
      ".ReactModalPortal--Subscription"
    );
  }

  public openModal() {
    if (this.state.modalIsOpen) {
      bodyScrollLock.enableBodyScroll(this.navigationRef);
    } else {
      bodyScrollLock.disableBodyScroll(this.navigationRef);
    }
    analytics.track("Register For Pioneer Access Opened", {
      category: "Visitor",
      label: "Register For Pioneer Access"
    });
    this.setState({ modalIsOpen: true });
  }

  public closeModal() {
    if (this.state.modalIsOpen) {
      bodyScrollLock.enableBodyScroll(this.navigationRef);
    } else {
      bodyScrollLock.disableBodyScroll(this.navigationRef);
    }
    analytics.track("Register For Pioneer Access Closed", {
      category: "Visitor",
      label: "X [Register For Pioneer Access]"
    });
    this.setState({ modalIsOpen: false });
  }

  public render() {
    const {
      className,
      title = "Request a demo",
      actionId = 2
    }: any = this.props;

    const iframe = (
      <IFrame
        url={`https://my.sendinblue.com/users/subscribe/js_id/2s1t2/id/${actionId}`}
        allowFullScreen
      />
    );
    return (
      <div>
        <Button
          extraClasses={className}
          href="javascript:void(0)"
          content={title}
          onClick={this.openModal}
        />
        <Modal
          extraClasses="ReactModalPortal--Subscription"
          isOpen={this.state.modalIsOpen}
          openModal={this.openModal}
          closeModal={this.closeModal}
        >
          {iframe}
        </Modal>
      </div>
    );
  }
}

export default Subscription;



// WEBPACK FOOTER //
// ./src/components/subscription.js/subscription.tsx